import React, { isValidElement } from "react";
import ReactDOMServer from "react-dom/server";
import TableCell from "react-base-table/es/TableCell";
import { renderElement, getValue } from "react-base-table/es/utils";
import { ExportToCsv } from "export-to-csv-fix-source-map";
import { isFunction, isString } from "./utils";
import { isTableBusy } from "./actions";

function extractContent(value) {
  const div = document.createElement("div");
  div.innerHTML = value;
  const text = div.textContent;
  return text;
}

const exportTableToCsv = (
  columns,
  data,
  csvFileName,
  onExportCSV,
  fireAction
) => {
  const headers = columns.map(col => {
    return isString(col.csvTitle)
      ? col.csvTitle
      : isString(col.title)
      ? col.title
      : "";
  });

  const getCSVData = dataValue => {
    return dataValue.map((rowData, rowIndex) => {
      const row = {};

      columns.forEach((column, columnIndex) => {
        const { dataGetter, dataKey, cellRenderer, key, getCsvValue } = column;
        const cellData = dataGetter
          ? dataGetter({ columns, column, columnIndex, rowData, rowIndex })
          : getValue(rowData, dataKey);
        const cellProps = {
          cellData,
          columns,
          column,
          columnIndex,
          rowData,
          rowIndex
        };
        const cell = renderElement(
          getCsvValue || cellRenderer || <TableCell />,
          cellProps
        );

        row[key] = isValidElement(cell)
          ? extractContent(ReactDOMServer.renderToString(cell))
          : cell;
      });

      return row;
    });
  };

  const options = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useTextFile: false,
    useBom: true,
    filename: csvFileName,
    headers
  };

  const csvExporter = new ExportToCsv(options);
  if (isFunction(onExportCSV)) {
    const promise = onExportCSV();
    if (promise instanceof Promise) {
      promise
        .then(csvResults => {
          csvExporter.generateCsv(getCSVData(csvResults));
        })
        .catch(error => {
          throw new Error(error);
        })
        .finally(() => {
          fireAction(isTableBusy(false));
        });
    }
  } else {
    csvExporter.generateCsv(getCSVData(data));
    fireAction(isTableBusy(false));
  }
};

export default exportTableToCsv;
